<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ShareRuleen',
})
</script>
<template>
  <div class="page">
    <header>
      <NavBar :title="lang('rule')" transparent> </NavBar>
    </header>
    <main>
      <div class="title">Eligible Participants:</div>
      <div class="text">J&T Malaysia App member</div>
      <div class="title">Benefits Details:</div>
      <div class="serial_wrap">
        <div class="serial">1.</div>
        <div class="text">
          Each member can earn points by inviting friends. For every friend
          referred to who becomes a new member, the new member must enter the
          referral code provided by the referrer, and the system will reward the
          referrer with 1,000 points.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">2.</div>
        <div class="text">
          The system will automatically issue a welcome package to each new
          user. The package includes:
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">1,000 points</div>
          </div>
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">One RM2 cash voucher</div>
          </div>
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">Two RM1 cash vouchers</div>
          </div>
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">One RM5 international cash voucher</div>
          </div>
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">3.</div>
        <div class="text">
          After the new user places and pays for an order, the system will
          reward the referrer as follows:
          <div class="serial_wrap">
            <div class="serial">a.</div>
            <div class="text">
              Starter Referrer:
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">500 points</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">One RM6 cash voucher</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">One RM5 international cash voucher</div>
              </div>
            </div>
          </div>
          <div class="serial_wrap">
            <div class="serial">b.</div>
            <div class="text">
              Top Referrer:
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">500 points</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">One RM6 cash voucher</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">One RM5 international cash voucher</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">Two RM3 next-day delivery cash vouchers</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">Two RM2 cash vouchers</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">4.</div>
        <div class="text">
          A Starter Referrer refers to existing members who successfully invite
          the first 4 new users to place orders and make payments, while a Top
          Referrer refers to existing members who successfully invite the 5th to
          8th new users to place orders and make payments.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">5.</div>
        <div class="text">
          The referral point rewards and coupon rewards are capped at the 8th
          new user.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">6.</div>
        <div class="text">
          Vouchers are valid for 90 days from the date of issuance or the date
          the user redeems them, whichever is later.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">7.</div>
        <div class="text">
          Points are valid for 365 days from the date of issuance or the date
          the user redeems them, whichever is later.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">8.</div>
        <div class="text">
          If a user account is identified as a risk account by J&T during this
          event, or if the user engages in machine cheating or other fraudulent
          activities, the organizer will cancel the participant's eligibility
          and has the right to revoke related rewards, pursuing legal action if
          necessary.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">9.</div>
        <div class="text">
          In the event of force majeure or changes in circumstances (including
          but not limited to major disaster events, activities requiring
          cessation or adjustment by government directives, severe cyberattacks,
          or system failures), J&T reserves the right to suspend or cancel this
          event and cease the issuance of related benefits.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">10.</div>
        <div class="text">
          J&T may modify or adjust the event rules based on the actual
          implementation of the event, and any changes will be published on the
          event page and will take effect immediately upon announcement.
        </div>
      </div>
    </main>
  </div>
</template>

<script lang="ts" setup name="ShareRuleen">
import NavBar from '@/components/NavBar.vue'
import lang from '@/langs'
// import { useRouter } from 'vue-router'

// const router = useRouter()
</script>

<style lang="less" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  :deep(.van-icon-arrow-left) {
    color: #fff !important;
  }
  :deep(.van-nav-bar__title) {
    color: #fff !important;
  }
  :deep(.van-nav-bar__content) {
    background: #e92124 !important;
  }
  .header_right {
    .flex_align_center;
  }
  .right_filter {
    width: 12px;
    height: 13px;
  }
}
header {
  width: 100%;
}
main {
  flex: 1;
  overflow-y: auto;
  margin-top: 10px;
  padding: 10px;
  padding-top: 0;
}
.title {
  font-size: 17px;
  font-weight: bold;
  color: #333333;
  line-height: 17px;
  margin-top: 20px;
}
.text {
  font-size: 16px;
  color: #333333;
  line-height: 21px;
  margin-top: 6px;
}
.serial_wrap {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2px;
}
.serial {
  color: #336df2;
  font-size: 16px;
  line-height: 21px;
  margin-top: 6px;
  margin-right: 6px;
}
.serial_round {
  width: 5px;
  height: 5px;
  border-radius: 3px;
  border: 1px solid #336df2;
  background: #fff;
  margin-right: 6px;
  margin-top: 13px;
}
.serial_rect {
  width: 4px;
  height: 4px;
  border: 1px solid #336df2;
  background: #336df2;
  margin-right: 6px;
  margin-top: 13px;
}
</style>
